import axios from 'axios';

export const getData = (apiUrl, setAppState, currState, identificator) => {
  axios.get(apiUrl).then(resp => {
    const allData = resp.data[identificator];
    setAppState([...currState, ...allData]);
  });
};
